/**
 * Created by zura on 08.06.20.
 */
import Vue from 'vue';
import moment from 'moment';

Vue.filter('capitalize', function (value, format) {
  if (!value) return '';
  value = value.toString();
  return value.charAt(0).toUpperCase() + value.slice(1);
});

